import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";

const SessionExpired = ({ data }) => {
  const Navigate = useNavigate();
  return (
    <div className="session-expired-container">
      <>
        <h3>{data?.session_expired}</h3>
        <div>{data?.do_assessment_text}</div>
        <Button
          onClick={() => Navigate(`${process.env.REACT_APP_BASE}/assessment`)}
        >
          Start The Assessment Now
        </Button>
      </>
    </div>
  );
};

export default SessionExpired;
